import React, {useContext} from "react";

import {Link as RouterLink} from 'react-router-dom';
// material
import {experimentalStyled as styled} from '@material-ui/core/styles';
import {Box, Card, Container, Hidden, Typography} from '@material-ui/core';
// components
import Page from '../../components/Page';
import Logo from '../../components/Logo';

import BDAuth from '../../components/BDAuth';
// context
import {BrandContext} from "../../contexts/BrandContext";
import LoginForm from "../../components/igtm/manuallogin/LoginForm";
import ManualLoginContextProvider from "../../components/igtm/manuallogin/ManualLoginContext"



// hooks


// ----------------------------------------------------------------------

const RootStyle = styled(Page)(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex'
  }
}));

const HeaderStyle = styled('header')(({ theme }) => ({
  top: 0,
  zIndex: 9,
  lineHeight: 0,
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  position: 'absolute',
  padding: theme.spacing(3),
  justifyContent: 'space-between',
  [theme.breakpoints.up('md')]: {
    alignItems: 'flex-start',
    padding: theme.spacing(7, 5, 0, 7)
  }
}));

const SectionStyle = styled(Card)(({ theme }) => ({
  width: '100%',
  maxWidth: 464,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  margin: theme.spacing(2, 0, 2, 2)
}));

const ContentStyle = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  display: 'flex',
  minHeight: '100vh',
  flexDirection: 'column',
  justifyContent: 'center',
  padding: theme.spacing(12, 0)
}));


// ----------------------------------------------------------------------

export default function Login() {


  const brandContext = useContext(BrandContext);


  return (
    <RootStyle title="Login | i-GTM">
      <HeaderStyle>
        <RouterLink to="/">
          <Logo />
        </RouterLink>

      </HeaderStyle>

      <Hidden mdDown>
        <SectionStyle>
          {(brandContext.isLoading === false && (Object.keys(brandContext.textContent).length !== 0)) &&
              <>
                <Typography variant="h3" sx={{ px: 5, mt: 15, mb: 15 }}>
                  {brandContext.textContent.welcomeTitleLoginPage}
                </Typography>
                {brandContext.brand.logoPath ?
                    <img style={{marginLeft:20}} src={brandContext.brand.logoPath} width="400" alt="login" />
                    :
                    <img style={{marginLeft:20}} src="/assets/img/logo.svg" width="400" alt="login" />
                }

              </>

          }

        </SectionStyle>
      </Hidden>

      <Container maxWidth="sm">
        {(brandContext.isLoading === false && (Object.keys(brandContext.textContent).length !== 0)) &&
        <ContentStyle>
          <Box sx={{mb: 5, display: 'flex', alignItems: 'center'}}>
            <Box sx={{flexGrow: 1}}>
              <Typography variant="h4" gutterBottom>
                {brandContext.textContent.signInToTitle}
              </Typography>
              <Typography sx={{color: 'text.secondary'}}>
                {brandContext.textContent.selectSignInMethodParentUi}
              </Typography>
              <br/>
              {brandContext.brand.isams &&
              <Typography sx={{color: 'text.secondary'}}>
                {brandContext.textContent.loginFormIsamsHelperText}
              </Typography>
              }
              {brandContext.brand.mySchoolPortal &&
              <Typography sx={{color: 'text.secondary'}}>
                {brandContext.textContent.loginFormMspHelperText}
              </Typography>
              }
              {brandContext.brand.fireFly &&
              <Typography sx={{color: 'text.secondary'}}>
                {brandContext.textContent.loginFormFireflyHelperText}
              </Typography>
              }
            </Box>

          </Box>
            <BDAuth/>
            <ManualLoginContextProvider>
              <LoginForm/>
            </ManualLoginContextProvider>
        </ContentStyle>
        }
      </Container>
    </RootStyle>
  );
  /* eslint-disable */
  /* eslint-enable */
}
